import React, { useState, useEffect, useRef } from 'react';
import DocumentDisplay from './DocumentDisplay';
import Sidebar from './Sidebar';
import DocActions from './DocActions';
import { compilationApi } from '@api/api';
import { SubstitutionContainer } from './DocPlaceholderSubstitution.styles';

const DocPlaceholderSubstitution = ({ incomingDocument, incomingVariables }) => {
    const [templateText, setTemplateText] = useState(incomingDocument);
    const [variables, setVariables] = useState({});
    const variablesRef = useRef(variables);
    const [renderedText, setRenderedText] = useState(templateText);

    useEffect(() => {
        setTemplateText(incomingDocument);
        setVariables(incomingVariables);
    }, [incomingDocument, incomingVariables])

    useEffect(() => {
        const regex = /\{\{([^}]+)\}\}/g;
        const foundVariables = {};
        let match;

        while ((match = regex.exec(templateText)) !== null) {
            const variableName = match[1];
            if (!variablesRef.current[variableName]) {
                foundVariables[variableName] = incomingVariables[variableName] ? incomingVariables[variableName] : '';
            }
        }

        setVariables((prevVariables) => ({
            ...prevVariables,
            ...foundVariables
        }));
    }, [templateText, incomingVariables]);

    useEffect(() => {
        variablesRef.current = variables;
    }, [variables]);

    useEffect(() => {
        let updatedDocument = templateText;
        Object.keys(variables).forEach((key) => {
            const regex = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
            updatedDocument = updatedDocument.replace(regex, variables[key] || `{${key}}`);
        });

        setRenderedText(updatedDocument);
    }, [variables, templateText]);

    const handleInputChange = (name, value) => {
        setVariables((prevVars) => ({
            ...prevVars,
            [name]: value
        }));
    };

    const handleDownloadPdf = async () => {
        try {
            const result = await compilationApi.compilePDF(renderedText);
            const url = window.URL.createObjectURL(result.blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', result.filename || 'the_document.pdf');

            document.body.appendChild(link);
            link.click();

            link.remove();
        } catch (error) {
            console.error('Error compiling PDF: ', error);
        }
    };

    const handleDownloadDocX = async () => {
        try {
            const result = await compilationApi.compileDOCX(renderedText);
            const url = window.URL.createObjectURL(result.blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', result.filename || 'the_document.docx');

            document.body.appendChild(link);
            link.click();

            link.remove();
        } catch (error) {
            console.error('Error compiling DocX: ', error);
        }
    };

    return (
            <SubstitutionContainer>
                <DocumentDisplay document={renderedText} />
                <Sidebar variables={variables} handleInput={handleInputChange}>
                    <DocActions onDownloadPdf={handleDownloadPdf} onDownloadDocX={handleDownloadDocX} />
                </Sidebar>
            </SubstitutionContainer>
    );
};

export default DocPlaceholderSubstitution;
